import { Controller } from "stimulus";

export default class PushNotificationsController extends Controller {
  async connect() {
    const serviceWorkerRegistration = await navigator.serviceWorker.ready;

    this.subscription = await serviceWorkerRegistration.pushManager.getSubscription();
    if (this.subscription) {
      this.subscribedTarget.classList.remove("hidden");
      this.unsubscribedTarget.classList.add("hidden");
    } else {
      this.unsubscribedTarget.classList.remove("hidden");
      this.subscribedTarget.classList.add("hidden");
    }
  }

  async subscribe() {
    const serviceWorkerRegistration = await navigator.serviceWorker.ready;

    await serviceWorkerRegistration.pushManager
      .subscribe({
        userVisibleOnly: true,
        applicationServerKey: "BHMWFIywBmHawqh7RzhwaeBKqIUrlhrttSeWDuNM-f8k4tTBQ0koxztGjj9_qqMDI-Fz5jltoLgnGOtbGVZiT-s"
      });

    this.subscriptionDataTarget.value = JSON.stringify(await serviceWorkerRegistration.pushManager.getSubscription());
    this.formTarget.submit();
  }

  async unsubscribe() {
    this.subscription.unsubscribe();
    this.subscriptionDataTarget.value = "";
    this.formTarget.querySelector("input[name=_method]").value = "delete";
    this.formTarget.submit();
  }
}

PushNotificationsController.targets = ["subscriptionData", "form", "subscribed", "unsubscribed"];

